import type { LoaderFunctionArgs } from "react-router-dom";
import { redirect } from "react-router-dom";
import type { GuardCheckResult, GuardLoaderFunction } from "../types/guard.type";

type CheckFunction = (args: LoaderFunctionArgs) => GuardCheckResult | Promise<GuardCheckResult>;

interface CompositeLoaderOptions {
  checks: CheckFunction[];
  defaultRedirect?: string;
}

export function createCompositeLoader(options: Readonly<CompositeLoaderOptions>): GuardLoaderFunction {
  const { checks, defaultRedirect = "/welcome" } = options;

  const compositeLoader = async function compositeLoader(args: LoaderFunctionArgs): Promise<null | Response> {
    for (const check of checks) {
      const result = await check(args);

      if (!result.allowed) {
        return redirect(result.redirectTo ?? defaultRedirect);
      }
    }

    return null;
  };

  return compositeLoader;
}

export function combineLoaders(...loaders: GuardLoaderFunction[]): GuardLoaderFunction {
  const combinedLoader = async function combinedLoader(args: LoaderFunctionArgs): Promise<null | Response> {
    for (const loader of loaders) {
      const result = await loader(args);

      const isResultNotNull = result !== null;
      if (isResultNotNull) {
        return result;
      }
    }
    return null;
  };

  return combinedLoader;
}
